import Component from 'flarum/common/Component';
import encodeQR from 'qr';

export default class QrCode extends Component {
  oncreate(vnode) {
    super.oncreate(vnode);
    this.draw(vnode.dom);
  }

  onupdate(vnode) {
    super.onupdate(vnode);
    this.draw(vnode.dom);
  }

  view() {
    return (
      <canvas
        className="ReferralQrCode"
        role="img"
        aria-label={this.attrs.label}
      />
    );
  }

  draw(canvas) {
    if (!this.attrs.value) return;

    const modules = encodeQR(this.attrs.value, 'raw', {
      ecc: 'medium',
      border: 3,
    });
    const scale = 5;
    const size = modules.length;
    const context = canvas.getContext('2d');

    canvas.width = size * scale;
    canvas.height = size * scale;
    context.imageSmoothingEnabled = false;
    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.fillStyle = '#272321';

    modules.forEach((row, y) => {
      row.forEach((filled, x) => {
        if (filled) context.fillRect(x * scale, y * scale, scale, scale);
      });
    });
  }
}
